"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  HeadphonesCustomerSupportQuestion: ['headphones-customer-support-question', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.5,18H3.75a3,3,0,0,1-3-3V12a3,3,0,0,1,3-3H4.5a.75.75,0,0,1,.75.75v7.5A.75.75,0,0,1,4.5,18Z', 'M20.25,18H19.5a.75.75,0,0,1-.75-.75V9.75A.75.75,0,0,1,19.5,9h.75a3,3,0,0,1,3,3v3A3,3,0,0,1,20.25,18Z', 'M3.75,9A8.25,8.25,0,0,1,12,.75h0A8.25,8.25,0,0,1,20.25,9', 'M15,21.75h2.25a3,3,0,0,0,3-3h0V18', 'M13.5,23.25H12a1.5,1.5,0,0,1-1.5-1.5h0a1.5,1.5,0,0,1,1.5-1.5h1.5a1.5,1.5,0,0,1,1.5,1.5h0A1.5,1.5,0,0,1,13.5,23.25Z', 'M9,8.25a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415v.256', 'M12,15.75a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,15.75h0']],
  HelpWheel: ['help-wheel', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.250 12.000 A3.750 3.750 0 1 0 15.750 12.000 A3.750 3.750 0 1 0 8.250 12.000 Z', 'M17.119 20.301L12.529 15.711', 'M15.711 12.53L20.301 17.119', 'M3.699 17.119L8.289 12.529', 'M11.471 15.712L6.881 20.301', 'M6.881 3.7L11.471 8.289', 'M8.289 11.471L3.699 6.881', 'M20.301 6.881L15.711 11.471', 'M12.529 8.289L17.119 3.7', 'M2.250 12.000 A9.750 9.750 0 1 0 21.750 12.000 A9.750 9.750 0 1 0 2.250 12.000 Z']],
  HeadphonesCustomerSupport: ['headphones-customer-support', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.5,18H3.75a3,3,0,0,1-3-3V12a3,3,0,0,1,3-3H4.5a.75.75,0,0,1,.75.75v7.5A.75.75,0,0,1,4.5,18Z', 'M20.25,18H19.5a.75.75,0,0,1-.75-.75V9.75A.75.75,0,0,1,19.5,9h.75a3,3,0,0,1,3,3v3A3,3,0,0,1,20.25,18Z', 'M3.75,9A8.25,8.25,0,0,1,12,.75h0A8.25,8.25,0,0,1,20.25,9', 'M15,21.75h2.25a3,3,0,0,0,3-3h0V18', 'M13.5,23.25H12a1.5,1.5,0,0,1-1.5-1.5h0a1.5,1.5,0,0,1,1.5-1.5h1.5a1.5,1.5,0,0,1,1.5,1.5h0A1.5,1.5,0,0,1,13.5,23.25Z']],
  QuestionHelpSquare: ['question-help-square', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V13.5', 'M12,16.5a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,16.5h0', 'M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z']],
  QuestionHelpMessage: ['question-help-message', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21.75,18.75H11.25l-6,4.5v-4.5h-3a1.5,1.5,0,0,1-1.5-1.5v-15A1.5,1.5,0,0,1,2.25.75h19.5a1.5,1.5,0,0,1,1.5,1.5v15A1.5,1.5,0,0,1,21.75,18.75Z', 'M9,6.75a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415v.256', 'M12,14.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,14.25h0']],
  HelpQuestionNetwork: ['help-question-network', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 21.000 A2.250 2.250 0 1 0 5.250 21.000 A2.250 2.250 0 1 0 0.750 21.000 Z', 'M4.679 19.502L6.749 18', 'M0.750 3.000 A2.250 2.250 0 1 0 5.250 3.000 A2.250 2.250 0 1 0 0.750 3.000 Z', 'M4.679 4.499L6.749 6', 'M18.750 21.000 A2.250 2.250 0 1 0 23.250 21.000 A2.250 2.250 0 1 0 18.750 21.000 Z', 'M19.322 19.502L17.252 18', 'M18.750 3.000 A2.250 2.250 0 1 0 23.250 3.000 A2.250 2.250 0 1 0 18.750 3.000 Z', 'M19.322 4.499L17.252 6', 'M12,17.25a.375.375,0,1,1-.375.375A.375.375,0,0,1,12,17.25', 'M9,9.75a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415v.631']],
  HeadphonesCustomerSupportHuman: ['headphones-customer-support-human', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.5,18H3.75a3,3,0,0,1-3-3V12a3,3,0,0,1,3-3H4.5a.75.75,0,0,1,.75.75v7.5A.75.75,0,0,1,4.5,18Z', 'M20.25,18H19.5a.75.75,0,0,1-.75-.75V9.75A.75.75,0,0,1,19.5,9h.75a3,3,0,0,1,3,3v3A3,3,0,0,1,20.25,18Z', 'M3.75,9A8.25,8.25,0,0,1,12,.75h0A8.25,8.25,0,0,1,20.25,9', 'M15,21.75h2.25a3,3,0,0,0,3-3h0V18', 'M13.5,23.25H12a1.5,1.5,0,0,1-1.5-1.5h0a1.5,1.5,0,0,1,1.5-1.5h1.5a1.5,1.5,0,0,1,1.5,1.5h0A1.5,1.5,0,0,1,13.5,23.25Z', 'M9,15.442a4.454,4.454,0,0,0,6,0', 'M9 9.985L9 11.297', 'M15 9.985L15 11.297']],
  UserQuestion: ['user-question', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.5,23.25V19.511l1.007.168A3,3,0,0,0,20,16.719V14.261l.935-.234a1.5,1.5,0,0,0,.884-2.287L20,9.011v-.75C20,3.835,15.521.3,10.182.8A8.994,8.994,0,0,0,6.5,17.547v5.7', 'M8.572,8.25a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415v.256', 'M11.572,15.75a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375h0']],
  LaptopHelpMessage: ['laptop-help-message', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21.75 15.75L21.75 18.75', 'M2.25,18.75V8.25a1.5,1.5,0,0,1,1.5-1.5H7.5', 'M14.584,18.75a2.976,2.976,0,0,1-5.168,0H.75v1.5a3,3,0,0,0,3,3h16.5a3,3,0,0,0,3-3v-1.5Z', 'M18.659,1.011a6.363,6.363,0,0,0-7.582,8.8L9.013,14l4.723-1.29a6.293,6.293,0,0,0,1.319.567,6.392,6.392,0,0,0,3.6-12.265Z', 'M15.007,5.657a1.875,1.875,0,1,1,1.875,1.875', 'M16.882,9.782a.375.375,0,1,0,.375.375.374.374,0,0,0-.375-.375h0']],
  BrowserUserHelpMessage: ['browser-user-help-message', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M16.125,4.875A1.875,1.875,0,1,1,18,6.75', 'M18,9a.375.375,0,1,0,.375.375A.375.375,0,0,0,18,9h0', 'M21.18,10.178a5.271,5.271,0,1,0-7.117-.738l-.656,3.779,2.532-1.561', 'M4.857 15.375 A3.375 3.375 0 1 0 11.607 15.375 A3.375 3.375 0 1 0 4.857 15.375 Z', 'M13.46,23.243A6.062,6.062,0,0,0,3,23.25', 'M18 14.25L18 23.25', 'M.75,23.25V3.75a3,3,0,0,1,3-3h7.5', 'M0.75 5.321L9.75 5.321']],
  HeadphonesCustomerSupportHuman1: ['headphones-customer-support-human-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.322,2.549a8.989,8.989,0,0,1,2.251,16.5v4.2', 'M9.322 11.250 A3.750 3.750 0 1 0 16.822 11.250 A3.750 3.750 0 1 0 9.322 11.250 Z', 'M10.822,8.25V1.5a.75.75,0,0,1,.75-.75h3a.75.75,0,0,1,.75.75V8.25', 'M4.073,15.761l-.936-.234a1.5,1.5,0,0,1-.884-2.287l1.82-2.729v-.75c0-3.542,2.868-6.511,6.749-7.3', 'M8.573,23.25V21.011l-1.007.167a2.978,2.978,0,0,1-1.244-.053', 'M13.072,11.25a7.5,7.5,0,0,1-7.5,7.5h-1.5']]
};
exports["default"] = _default;